<template>
  <a-card :bordered="false" title="编辑">
    <a-form-model
      :model="form"
      ref="ruleForm"
      :label-col="currentFormLayout.labelCol"
      :wrapper-col="currentFormLayout.wrapperCol"
    >
      <a-form-model-item label="同步状态">
        <a-radio-group v-model="form.synchronizationStatus">
          <a-radio :value="0">禁用</a-radio>
          <a-radio :value="1">正常</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="商品同步">
        <a-radio-group v-model="form.productSynchronization">
          <a-radio :value="0">关闭</a-radio>
          <a-radio :value="1">开启</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="订单同步">
        <a-radio-group v-model="form.orderSynchronization">
          <a-radio :value="0">关闭</a-radio>
          <a-radio :value="1">开启</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="商品来源">
        <a-checkbox-group v-model="form.productSourceCheckList">
          <a-checkbox v-for="(item, index) in productSourceOptions" :value="item.value" :key="index"
          >{{ item.label }}
          </a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item label="订单来源">
        <a-checkbox-group v-model="form.orderSourceCheckList">
          <a-checkbox v-for="(item, index) in orderSourceOptions" :key="index" :value="item.value"
          >{{ item.label }}
          </a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item style="text-align: center">
        <a-button type="primary" style="width: 200px" @click="onSave">保存</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
export default {
  name: 'ErpConnectSetting',
  data() {
    return {
      currentFormLayout: {
        labelCol: {
          xxl: { span: 2 },
          xl: { span: 3 },
          lg: { span: 3 },
          sm: { span: 5 },
          md: { span: 8 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 22 }, //≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 }, //≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 19 }, //≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 19 }, //≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 }, //≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 } //xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      id: '',
      form: {
        orderSource: 0, //订单来源：1全部订单 2仅自有商品销售订单 3仅分销商品订单
        orderSourceCheckList: [], //
        orderSynchronization: 0, //: 订单同步：0关闭 1开启
        productSource: 0, //商品来源:0自有商品 1平台直采 2云仓分销
        productSourceCheckList: [],
        productSynchronization: 0, //商品同步：0关闭 1开启
        synchronizationStatus: 0 //同步状态：0禁用 1开启
      },
      productSourceOptions: [
        {
          label: '自有商品',
          value: '0'
        },
        {
          label: '平台直采',
          value: '1'
        },
        {
          label: '云仓分销',
          value: '2'
        }
      ],
      orderSourceOptions: [
        {
          label: '全部订单',
          value: '1'
        },
        {
          label: '仅自有商品销售订单',
          value: '2'
        },
        {
          label: '仅分销商品订单',
          value: '3'
        }
      ]
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [{ name: 'ErpConnectList', title: '设置' }, {
      name: 'ErpApiSetting',
      title: 'API配置'
    }])
  },
  mounted() {
    this.id = this.$route.query.id
    this.getDetails(this.id)
  },
  methods: {
    getDetails(id) {
      let url = 'directAssistant/search/getDetail/' + id
      this.getHttpServices()
        .getServerApiService()
        .post(url, {})
        .then(res => {
          res.orderSourceCheckList = res.orderSource.split(',')
          res.productSourceCheckList = res.productSource.split(',')
          this.form = res
          this.getLogUtils().logWithTag('===getDetails===', this.form)
        })
        .catch(reason => {
          this.getLogUtils().logWithTag('===getDetails===', reason)
        })
    },

    onSave() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.requestSubmit()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    requestSubmit() {
      let url = 'directAssistant/operating/edit'
      let params = {
        id: this.id,
        orderSource: this.form.orderSourceCheckList.join(','),
        orderSynchronization: this.form.orderSynchronization,
        productSource: this.form.productSourceCheckList.join(','),
        productSynchronization: this.form.productSynchronization,
        synchronizationStatus: this.form.synchronizationStatus
      }
      this.getHttpServices()
        .getServerApiService()
        .post(url, params)
        .then(res => {
          this.$message.success('保存成功')
          this.$router.back(-1)
        })
        .catch(reason => {
          this.$message.error('保存失败，请重试')
        })
    }
  }
}
</script>
<style scoped>
</style>
